<template>
  <v-dialog
    v-model="getModalAtualizarTabelaNCM"
    persistent
    max-width="500px"
    transition="dialog-transition"
  >
    <v-card :loading="$store.getters.getOverlay">
      <v-card-title> Atualização tabela IBPT Lei 12.741/12 </v-card-title>
      <v-card-text>
        <h3 align="center">Tem certeza que deseja atualizar a tabela?</h3>
      </v-card-text>
      <v-card-actions>
        <v-btn
          color="default"
          outlined
          @click="setModalAtualizarTabelaNCM(false)"
          :loading="$store.getters.getOverlay"
          >Voltar</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn
          color="success"
          outlined
          @click="atualizarTabelaNCM()"
          :loading="$store.getters.getOverlay"
          >Atualizar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
  computed: {
    ...mapGetters(["getModalAtualizarTabelaNCM"]),
  },
  methods: {
    ...mapActions(["atualizarTabelaNCM", "setModalAtualizarTabelaNCM"]),
  },
};
</script>